import React, { useState } from "react";
import axiosClient from "../../api/axiosClient";
import ContentEditor from "./components/ContentEditor";

const initialForm = {
    title: "",
    slug: "",
    status: "draft",
    description: "",
    content: "",
    featuredImage: "",
    projectUrl: "",
};

const ProjectEditor = () => {
    const [form, setForm] = useState(initialForm);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");
    const [apiError, setApiError] = useState("");
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setApiError("");
        setMessage("");
        try {
            const response = await axiosClient.post("/projects", {
                ...form,
                status: form.status || "draft",
            });
            setMessage(response.data.message || "Project created!");
            setForm(initialForm);
        } catch (err) {
            setApiError(
                err.response?.data?.message || "Failed to create project. Please try again."
            );
        } finally {
            setSaving(false);
        }
    };
    
    return (
        <div className="container mt-4" style={{ maxWidth: "850px" }}>
            <h2 className="mb-4">Create New Project</h2>
            
            {message && (
                <div className="alert alert-success" role="alert">
                    {message}
                </div>
            )}
            {apiError && (
                <div className="alert alert-danger" role="alert">
                    {apiError}
                </div>
            )}
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">Title</label>
                    <input
                        className="form-control"
                        name="title"
                        value={form.title}
                        onChange={handleChange}
                        required
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Slug</label>
                    <input
                        className="form-control"
                        name="slug"
                        value={form.slug}
                        onChange={handleChange}
                        required
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                        className="form-select"
                        name="status"
                        value={form.status}
                        onChange={handleChange}
                    >
                        <option value="draft">Draft</option>
                        <option value="published">Published</option>
                    </select>
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                        className="form-control"
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                        rows={2}
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Content</label>
                    <ContentEditor
                        value={form.content}
                        onChange={(content) =>
                            setForm((prev) => ({ ...prev, content }))
                        }
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Featured Image URL</label>
                    <input
                        className="form-control"
                        name="featuredImage"
                        value={form.featuredImage}
                        onChange={handleChange}
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Project URL</label>
                    <input
                        className="form-control"
                        name="projectUrl"
                        value={form.projectUrl}
                        onChange={handleChange}
                    />
                </div>
                
                <button type="submit" className="btn btn-primary" disabled={saving}>
                    {saving ? "Saving..." : "Publish"}
                </button>
            </form>
        </div>
    );
};

export default ProjectEditor;
